import { z } from "zod";
import { contactSchema } from "./Contact";
import { goodslineSchema } from "./Goodsline";
import { add } from "date-fns";

export const addressSchema = z.object({
  type: z.string().min(2).max(2).nullish(),
  addressId: z.string().nullish().readonly(),
  name: z.string().min(1).max(50),
  street1: z.string().min(1).max(35),
  street2: z.string().max(35).optional(),
  countryCode: z.string().min(2).max(2),
  city: z.string().min(1).max(50),
  zipCode:z.string().min(1).max(15),
  vatNo: z.string().max(20).optional(),
  contact: contactSchema.optional()
});

export const addressRegisterSchema = z.object({
  ...addressSchema.shape,
  prefill: z.object({
    deliveryType: z.string().max(50).optional(),
    customerNumber: z.string().max(50).optional(),
    pallRegNo: z.string().max(50).optional(),
    combiterms: z.string().max(10).optional(),
    receiverPays: z.boolean().default(false),
    goodsLines: z.array(goodslineSchema).max(1).optional()
  }).optional()
})

export type AddressType = z.infer<typeof addressSchema>;
export type AddressRegisterType = z.infer<typeof addressRegisterSchema>;